export class DisplayedChannel {
    channelContent: string = ""
    name: string = ""
    units: string = ""

    constructor(init?: Partial<DisplayedChannel>) {
        if (!init) {
            return
        }

        Object.assign(this, init)
    }
}